export class ModelSagres {
  /**
   * Gera uma versão FormData desta classe. Lida bem com datas, booleans, numbers e strings.
   * @since 20220613
   */
  toFormData(): FormData {
    const data = new FormData();
    for (const key in this) {
      // console.log(typeof (this[key]))
      if (this[key] instanceof Date) {
        data.append(key, (this[key] as unknown as Date).toISOString());
      } else if (this[key] instanceof File) {
        data.append(key, this[key] as unknown as Blob);
      } else if (this[key] !== null && this[key] !== undefined) {
        data.append(key, String(this[key]));
      }
    }
    // console.table([...data])
    return data;
  }

  /**
   * Valida se um valor está preenchido, geralmente ele está bind num form qualquer
   * @param value {String|Number|Date|Object}
   * @returns boolean
   * @since 20231108
   */
  isValid(value: any): boolean {
    if (typeof value === "string") {
      return value !== null && value !== undefined && value.trim().length > 0;
    }
    if (typeof value === "number") {
      return value !== null && value !== undefined && value > 0;
    }
    if (value instanceof Date) {
      return value !== null && value !== undefined;
    }
    if (typeof value === "object") {
      return value !== null && value !== undefined;
    }
    return false;
  }
}
